var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUtilization2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 131,
    viewBox: "0 0 208 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V162H207V7C207 3.68629 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2414 40.7539C43.2825 40.7539 41.6946 42.3419 41.6946 44.3007C41.6946 46.2595 43.2825 47.8475 45.2414 47.8475H163.419C165.378 47.8475 166.966 46.2595 166.966 44.3007C166.966 42.3419 165.378 40.7539 163.419 40.7539H45.2414Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 41C43.567 41 42 42.567 42 44.5C42 46.433 43.567 48 45.5 48H147.193C149.126 48 150.693 46.433 150.693 44.5C150.693 42.567 149.126 41 147.193 41H45.5Z",
    fill: "#D1D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.379 40.7539C177.42 40.7539 175.833 42.3419 175.833 44.3007C175.833 46.2595 177.42 47.8475 179.379 47.8475H194.476C196.435 47.8475 198.023 46.2595 198.023 44.3007C198.023 42.3419 196.435 40.7539 194.476 40.7539H179.379Z",
    fill: "#D1D3D4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 54C29.5228 54 34 49.5228 34 44C34 38.4772 29.5228 34 24 34C18.4772 34 14 38.4772 14 44C14 49.5228 18.4772 54 24 54Z",
    fill: "#A6A8AB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8005 47.102C26.759 47.102 26.7175 47.0606 26.676 47.0606C26.0536 46.8116 25.1822 46.3137 25.1822 45.6083C25.1822 44.5294 26.427 44.3635 26.593 42.1643C26.7175 40.3801 25.7631 39.0938 23.9789 39.0938C22.1947 39.0938 21.2403 40.3801 21.3648 42.1643C21.5308 44.405 22.7756 44.5709 22.7756 45.6083C22.7756 46.3137 21.9042 46.8116 21.2818 47.0606C21.2403 47.0606 21.1988 47.102 21.1573 47.102C20.8254 47.268 20.5764 47.6415 20.5764 48.0564C20.5764 48.6373 21.0328 49.0938 21.6138 49.0938H23.9789H26.344C26.925 49.0938 27.3814 48.6373 27.3814 48.0564C27.4229 47.6415 27.1739 47.268 26.8005 47.102Z",
    fill: "#BBBDBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2414 68.7539C43.2825 68.7539 41.6946 70.3419 41.6946 72.3007C41.6946 74.2595 43.2825 75.8475 45.2414 75.8475H163.419C165.378 75.8475 166.966 74.2595 166.966 72.3007C166.966 70.3419 165.378 68.7539 163.419 68.7539H45.2414Z",
    fill: "#E1E1E1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 69C43.567 69 42 70.567 42 72.5C42 74.433 43.567 76 45.5 76H66.4211C68.3541 76 69.9211 74.433 69.9211 72.5C69.9211 70.567 68.3541 69 66.4211 69H45.5Z",
    fill: "#D1D1D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.379 68.7539C177.42 68.7539 175.833 70.3419 175.833 72.3007C175.833 74.2595 177.42 75.8475 179.379 75.8475H194.476C196.435 75.8475 198.023 74.2595 198.023 72.3007C198.023 70.3419 196.435 68.7539 194.476 68.7539H179.379Z",
    fill: "#D1D3D4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 82C29.5228 82 34 77.5228 34 72C34 66.4772 29.5228 62 24 62C18.4772 62 14 66.4772 14 72C14 77.5228 18.4772 82 24 82Z",
    fill: "#A6A8AB"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8005 75.102C26.759 75.102 26.7175 75.0606 26.676 75.0606C26.0536 74.8116 25.1822 74.3137 25.1822 73.6083C25.1822 72.5294 26.427 72.3635 26.593 70.1643C26.7175 68.3801 25.7631 67.0938 23.9789 67.0938C22.1947 67.0938 21.2403 68.3801 21.3648 70.1643C21.5308 72.405 22.7756 72.5709 22.7756 73.6083C22.7756 74.3137 21.9042 74.8116 21.2818 75.0606C21.2403 75.0606 21.1988 75.102 21.1573 75.102C20.8254 75.268 20.5764 75.6415 20.5764 76.0564C20.5764 76.6373 21.0328 77.0938 21.6138 77.0938H23.9789H26.344C26.925 77.0938 27.3814 76.6373 27.3814 76.0564C27.4229 75.6415 27.1739 75.268 26.8005 75.102Z",
    fill: "#BBBDBF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2414 96.7539C43.2825 96.7539 41.6946 98.3419 41.6946 100.301C41.6946 102.26 43.2825 103.848 45.2414 103.848H163.419C165.378 103.848 166.966 102.26 166.966 100.301C166.966 98.3419 165.378 96.7539 163.419 96.7539H45.2414Z",
    fill: "#E1E1E1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 97C43.567 97 42 98.567 42 100.5C42 102.433 43.567 104 45.5 104H132.235C134.168 104 135.735 102.433 135.735 100.5C135.735 98.567 134.168 97 132.235 97H45.5Z",
    fill: "#D1D1D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.379 96.7539C177.42 96.7539 175.833 98.3419 175.833 100.301C175.833 102.26 177.42 103.848 179.379 103.848H194.476C196.435 103.848 198.023 102.26 198.023 100.301C198.023 98.3419 196.435 96.7539 194.476 96.7539H179.379Z",
    fill: "#D1D3D4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 110C29.5228 110 34 105.523 34 100C34 94.4772 29.5228 90 24 90C18.4772 90 14 94.4772 14 100C14 105.523 18.4772 110 24 110Z",
    fill: "#A6A8AB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8005 103.102C26.759 103.102 26.7175 103.061 26.676 103.061C26.0536 102.812 25.1822 102.314 25.1822 101.608C25.1822 100.529 26.427 100.363 26.593 98.1643C26.7175 96.3801 25.7631 95.0938 23.9789 95.0938C22.1947 95.0938 21.2403 96.3801 21.3648 98.1643C21.5308 100.405 22.7756 100.571 22.7756 101.608C22.7756 102.314 21.9042 102.812 21.2818 103.061C21.2403 103.061 21.1988 103.102 21.1573 103.102C20.8254 103.268 20.5764 103.641 20.5764 104.056C20.5764 104.637 21.0328 105.094 21.6138 105.094H23.9789H26.344C26.925 105.094 27.3814 104.637 27.3814 104.056C27.4229 103.641 27.1739 103.268 26.8005 103.102Z",
    fill: "#BBBDBF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2414 124.754C43.2825 124.754 41.6946 126.342 41.6946 128.301C41.6946 130.26 43.2825 131.848 45.2414 131.848H163.419C165.378 131.848 166.966 130.26 166.966 128.301C166.966 126.342 165.378 124.754 163.419 124.754H45.2414Z",
    fill: "#E1E1E1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.5 125C43.567 125 42 126.567 42 128.5C42 130.433 43.567 132 45.5 132H120.269C122.202 132 123.769 130.433 123.769 128.5C123.769 126.567 122.202 125 120.269 125H45.5Z",
    fill: "#D1D1D1"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.379 124.754C177.42 124.754 175.833 126.342 175.833 128.301C175.833 130.26 177.42 131.848 179.379 131.848H194.476C196.435 131.848 198.023 130.26 198.023 128.301C198.023 126.342 196.435 124.754 194.476 124.754H179.379Z",
    fill: "#D1D3D4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 138C29.5228 138 34 133.523 34 128C34 122.477 29.5228 118 24 118C18.4772 118 14 122.477 14 128C14 133.523 18.4772 138 24 138Z",
    fill: "#A6A8AB"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.8005 131.102C26.759 131.102 26.7175 131.061 26.676 131.061C26.0536 130.812 25.1822 130.314 25.1822 129.608C25.1822 128.529 26.427 128.363 26.593 126.164C26.7175 124.38 25.7631 123.094 23.9789 123.094C22.1947 123.094 21.2403 124.38 21.3648 126.164C21.5308 128.405 22.7756 128.571 22.7756 129.608C22.7756 130.314 21.9042 130.812 21.2818 131.061C21.2403 131.061 21.1988 131.102 21.1573 131.102C20.8254 131.268 20.5764 131.641 20.5764 132.056C20.5764 132.637 21.0328 133.094 21.6138 133.094H23.9789H26.344C26.925 133.094 27.3814 132.637 27.3814 132.056C27.4229 131.641 27.1739 131.268 26.8005 131.102Z",
    fill: "#BBBDBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilization2);
export default __webpack_public_path__ + "static/media/Utilization2.72b680ae529ddb6393629009e8678e9e.svg";
export { ForwardRef as ReactComponent };